import styles from "src/assets/styles/requestCall/requestCall.module.scss";
import CheckBox from "./checkBox";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import SuccessModal from "./successModal";
import { useDispatch, useSelector } from "react-redux";
import actions from "src/store/requestCall/actions";
import useFormatById from "src/hooks/utils/useFormatById";

const georgianPhoneNumberRegex = /^(5\d{8})$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function RequestCall() {
  const imedil_ge = process.env.REACT_APP_CLIENT_MAIN_URL;
  const f = useFormatById();
  const { productId } = useParams();
  const dispatch = useDispatch();

  const products = {
    autoset: "05111B3D55",
    autoclick: "351B3241BF",
    "uno-active": "7D1145DBD0",
    "uno-select": "443D161B8E",
    "uno-comfort": "B8D0BC555C",
    uno: "21A46F1B8B",
    "auto-car": "A09204994A",
  };
  const product = products[productId];

  const marketingCheckboxDocument = () => {
    // if (productId.startsWith("auto")) {
    //   return "data-for-marketing";
    // }
    return "data-for-marketing";
    // add coresponding urls based on product
  };

  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");
  const [acceptedMarketing, setAcceptedMarketing] = useState(false);
  const [acceptedPersonal, setAcceptedPersonal] = useState(false);
  const [preferContact, setPreferContact] = useState("phoneNumber");

  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

  const [errors, setErrors] = useState({
    name: false,
    phoneNumber: false,
    acceptedMarketing: false,
    acceptedPersonal: false,
  });

  const token = useSelector((state) => state.requestCall.token);
  const callRequestHasBeenSent = useSelector(
    (state) => state.requestCall.callRequestHasBeenSent
  );
  const callRequestLoading = useSelector(
    (state) => state.requestCall.isLoading
  );
  const lang = useSelector((state) => state.common.lang);

  const submitHandler = (e) => {
    e.preventDefault();

    // Reset errors before validation
    let hasErrors = false;
    const newErrors = {
      name: name?.length === 0 ? f("requestCall.requiredField") : false,
      phoneNumber:
        phoneNumber?.length === 0
          ? f("requestCall.requiredField")
          : !georgianPhoneNumberRegex.test(phoneNumber)
          ? f("requestCall.phoneNumberError")
          : false,

      email:
        email && !emailRegex.test(email)
          ? f("requestCall.emailError")
          : preferContact === "email" && email?.length === 0
          ? f("requestCall.requiredField")
          : false,
      comment: comment && comment?.length === 0,
      // acceptedMarketing: !acceptedMarketing,
      acceptedPersonal: !acceptedPersonal,
    };

    // Set error state if any validation fails
    setErrors(newErrors);
    hasErrors = Object.values(newErrors).some((error) => error);

    // If no errors, submit the form
    if (!hasErrors && !callRequestLoading && acceptedPersonal) {
      // Handle successful form submission
      dispatch(actions.getServiceToken());
    }
  };

  useEffect(() => {
    if (token) {
      dispatch(
        actions.getSendCallRequest({
          token: token,
          data: {
            ModuleId: product,
            Name: name,
            Mobile: phoneNumber,
            Email: email,
            Comment: comment,
            Language: lang,
            preferPhone: preferContact === "phoneNumber",
          },
        })
      );
    }
  }, [token, comment, dispatch, lang, email, name, phoneNumber, product]);

  useEffect(() => {
    if (callRequestHasBeenSent) {
      setIsSuccessModalOpen(true);
      setName("");
      setPhoneNumber("");
      setEmail("");
      setComment("");
      setAcceptedMarketing(false);
      setAcceptedPersonal(false);
    }
  }, [callRequestHasBeenSent]);

  return (
    <>
      {callRequestHasBeenSent && (
        <SuccessModal
          onClose={() => dispatch(actions.setCallRequestHasBeenSent(undefined))}
        />
      )}
      <div className={styles.formContainer}>
        <h1>{f("requestCall.leaveContactInformation")}</h1>
        <p className={styles.subTitle}>{f("requestCall.subTitle")}</p>

        <form onSubmit={submitHandler}>
          <p className={styles.preferParagraph}>
            {f("requestCall.preferContactText")}
          </p>

          <div className={styles.preferContactCheckboxesWrapper}>
            <CheckBox
              name={"prefer_mobile_phone"}
              labelComponent={
                <p className={styles.preferLabel}>
                  {f("requestCall.onPhoneNumber")}
                </p>
              }
              value={preferContact === "phoneNumber"}
              onChange={(e) => setPreferContact("phoneNumber")}
              // hasError={errors.acceptedMarketing}
            />

            <CheckBox
              name={"prefer_email"}
              labelComponent={
                <p className={styles.preferLabel}>{f("requestCall.onEmail")}</p>
              }
              value={preferContact === "email"}
              onChange={(e) => setPreferContact("email")}
              // hasError={errors.acceptedMarketing}
            />
          </div>

          <div className={styles.inputWrapper}>
            <input
              placeholder={f("requestCall.name")}
              type="text"
              className={`${errors.name && styles.hasError}`}
              onChange={(e) => setName(e.target.value)}
              value={name}
            />
            {errors.name && (
              <p className={styles.errorMessage}>
                {f("requestCall.requiredField")}
              </p>
            )}
          </div>
          <div className={styles.inputWrapper}>
            <input
              placeholder={f("requestCall.phoneNumber")}
              type="number"
              className={`${errors.phoneNumber && styles.hasError}`}
              onChange={(e) => setPhoneNumber(e.target.value)}
              value={phoneNumber}
            />
            {errors.phoneNumber && (
              <p className={styles.errorMessage}>{errors.phoneNumber}</p>
            )}
          </div>

          <div className={styles.inputWrapper}>
            <input
              placeholder={f("requestCall.email")}
              type="email"
              className={`${errors.email && styles.hasError}`}
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
            {errors.email && (
              <p className={styles.errorMessage}>{errors.email}</p>
            )}
          </div>

          <div className={styles.inputWrapper}>
            <textarea
              placeholder={f("requestCall.comment")}
              className={`${errors.commment && styles.hasError}`}
              onChange={(e) => setComment(e.target.value)}
              value={comment}
            />
          </div>
          <div className={styles.checkBoxesWrapper}>
            {errors.acceptedPersonal && (
              <p className={`${styles.errorMessage} ${styles.checkBoxError}`}>
                {f("requestCall.pleaseAgreeDataProcessingRule")}
              </p>
            )}
            <CheckBox
              name={"accept_marketing"}
              labelComponent={
                <>
                  {f("requestCall.acceptedMarketingText")}
                  <a
                    target="_blank"
                    href={`${imedil_ge}/legal-info/${marketingCheckboxDocument()}/ge`}
                  >
                    {f("requestCall.acceptedMarketingLink")}
                  </a>
                </>
              }
              value={acceptedMarketing}
              onChange={(e) => setAcceptedMarketing(e.target.checked)}
              hasError={errors.acceptedMarketing}
            />

            <CheckBox
              name={"accept_personal"}
              labelComponent={
                <>
                  {f("requestCall.acceptedPersonalInformationText")}
                  <a
                    target="_blank"
                    href={`${imedil_ge}/legal-info/personal-data/ge`}
                  >
                    {f("requestCall.acceptedPersonalInformationLink")}
                  </a>
                </>
              }
              value={acceptedPersonal}
              onChange={(e) => setAcceptedPersonal(e.target.checked)}
              hasError={errors.acceptedPersonal}
            />
          </div>
          <button
            // disabled={
            //   !name.length > 0 ||
            //   !georgianPhoneNumberRegex.test(phoneNumber) ||
            //   !acceptedPersonal ||
            //   (email && !emailRegex.test(email))
            // }
            disabled={callRequestLoading}
            className={styles.submitButton}
            type="submit"
          >
            {f("requestCall.send")}
          </button>
        </form>
      </div>
    </>
  );
}

export default RequestCall;
